import {LOGIN, LOGOUT, SET_DEPARTMENT, UPDATE_INFO, SET_DEPARTMENTS} from "./types";

export const userLogin = content => ({
    type: LOGIN,
    userData: content
})

export const userUpdateInfo = content => ({
    type: UPDATE_INFO,
    userData: content
})

export const userLogout = content => ({
    type: LOGOUT
})

export const setDepartment = content => ({
    type: SET_DEPARTMENT,
    currentDepartment: content
})

export const setDepartments = content => ({
    type: SET_DEPARTMENTS,
    data: content
})